/**
 * First external_email preview event from AT packet notificationEvents (if any).
 */
export function findExternalEmailPreviewFromEvents(events) {
  if (!Array.isArray(events)) return null;
  const ev = events.find((e) => e && e.channel === 'external_email' && e.status === 'preview');
  if (!ev) return null;
  return {
    subject: ev.subject ?? '',
    body: ev.body ?? '',
    recipientsPreview: ev.recipientsPreview,
    statusCode: ev.statusCode,
  };
}
